<template>
  <div id="login">
    <h1>Login</h1>
    <input type="text" name="username" v-model="input.username" placeholder="Username" />
    <input type="password" name="password" v-model="input.password" placeholder="Password" />
    <button type="button" v-on:click="login()">Login</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: {
        username: '',
        password: '',
      },
    };
  },
  methods: {
    login() {
      this.$store
        .dispatch('login') // TODO
        .then(() => {
          this.$router.push('/').catch(err => {
            this.$log.error(err);
          });
        })
        .catch(() => {
          this.$log.error('failed login');
        });
    },
  },
};
</script>
